import { useEffect, useState } from 'react';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './services/Theme';

import { Typography, Box, Paper, Grid, FormControl, InputLabel, Select, MenuItem, Button, OutlinedInput } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import './App.css';

let base_url = "";

if (typeof(document.getElementById('contact-init-frontend')) != 'undefined' && document.getElementById('contact-init-frontend') != null)
{

  const root_element = document.getElementById('contact-init-frontend');
  base_url = root_element.getAttribute('data-base-url');

}else{

  base_url = "https://felmi-zfe.at/";

}



function App() {

  const [successInfo, setSuccessInfo] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [loading, setLoading] = useState(false);

  const [materialChoice, setMaterialChoice] = useState('');
  const [methodChoice, setMethodChoice] = useState('');
  const [taskChoice, setTaskChoice] = useState('');

  const [materialList, setMaterialList] = useState(null);
  const [methodList, setMethodList] = useState(null);
  const [taskList, setTaskList] = useState(null);

  const [contactPerson, setContactPerson] = useState(null);
  const [basicContactPerson, setBasicContactPerson] = useState(null);
  
  const [formName, setFormName] = useState(null);
  const [formEmail, setFormEmail] = useState(null);
  const [formCompany, setFormCompany] = useState(null);
  const [formTask, setFormTask] = useState('');
  const [formOther, setFormOther] = useState(null);

  const [formError, setFormError] = useState(false);
  const [formEmailError, setFormEmailError] = useState(false);

  const handleGetMaterials = () => {
    axios.get(base_url+'/wp-json/wp/v2/init-contact_materials')
      .then(function (response) {
        setMaterialList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleGetMethods = () => {
    axios.get(base_url+'/wp-json/wp/v2/init-contact_methods')
      .then(function (response) {
        setMethodList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleGetTasks = () => {
    axios.get(base_url+'/wp-json/wp/v2/init-contact_task')
      .then(function (response) {
        setTaskList(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  const handleMaterialChoice = (event) => {
    setMaterialChoice(event.target.value);
  }

  const handleMethodChoice = (event) => {
    setMethodChoice(event.target.value);
  }

  const handleSearch = () => {

    let url = "";

    if (materialChoice !== "" && methodChoice !== "") {

      url = base_url+'/wp-json/wp/v2/init-contact?init-contact_materials='+materialChoice+'&init-contact_methods='+methodChoice;

    }else if(materialChoice !== "" && methodChoice === ""){

      url = base_url+'/wp-json/wp/v2/init-contact?init-contact_materials='+materialChoice;

    }else if(methodChoice !== "" && materialChoice === ""){

      url = base_url+'/wp-json/wp/v2/init-contact?init-contact_methods='+methodChoice;

    }else{

      url = base_url; 

    }

    axios.get(url)
      .then(function (response) {
        setContactPerson(response.data);
        if (response.data.length !== 0) {
          setShowSearch(true);
        }else{
          axios.get(base_url+"/wp-json/wp/v2/init-contact?include=3515,3514").then(function(basic_response){
            setBasicContactPerson(basic_response.data);
          })
          .catch(function(basic_error){
            console.log(basic_error);
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleReset = () => {
    setShowSearch(false);

    setMethodChoice('');
    setMaterialChoice('');
    setTaskChoice('');
    setContactPerson(null);

    setFormName(null);
    setFormCompany(null);
    setFormEmail(null);
    setFormError(false);
    setFormEmailError(false);
    setFormOther(null);
    setFormTask('');
    setLoading(false);

  }


  const handleFormInputChange = (event) => {

    if (event.target.id === "name") {
      setFormName(event.target.value);
    }

    if (event.target.id === "email") {
      setFormEmail(event.target.value);
    }

    if (event.target.id === "company") {
      setFormCompany(event.target.value);
    }

    if (event.target.id === "others") {
      setFormOther(event.target.value);
    }

    if (event.target.name === "tasks") {
      setTaskChoice(event.target.value);
      setFormTask(taskList.filter((item) => item.id === event.target.value)[0].name);
    }

  }


  const handleFormSubmit = () => {

    setFormError(false);
    setFormEmailError(false);

    if (handleFormValidate()) {
      
      setFormError(true);

    }else{


      if(validateEmail(formEmail)){

        setFormEmailError(true);

      }else{

        setLoading(true);
  
        let formdata = {        
          contact_person_name: contactPerson[0].title.rendered,
          contact_person_email: contactPerson[0].acf.email,
          contact_person_phone: contactPerson[0].acf.phonenumber,
          name: formName,
          email: formEmail,
          company: formCompany,
          task: formTask,
          others: formOther
        };
  
        axios.post(base_url+'dmscript/public/api/send-contact-email', formdata)
          .then(function (response) {
            handleReset();
            setSuccessInfo(true);
          })
          .catch(function (error) {
            console.log(error);
          });

      }

    }

  }


  const handleFormValidate = () => {

    let error = false;

    if (formName === null || formName === " ") {
      error = true;
    }

    if (formEmail === null || formEmail === " ") {
      error = true;
    }

    return error;

  }

  const validateEmail = (email) => {
    let isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    if(email && email.match(isValidEmail)){
      return false;
    }else{
      return true;
    }
  }


  useEffect(() => {
    handleGetMaterials();
    handleGetMethods();
    handleGetTasks();
  }, [])

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box sx={{ p: 4 }} component={Paper}>
          {successInfo ? ( 
            <Box sx={{ p: 4, border: '1px solid green', color: 'green', mb: 3, display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body1" sx={{ pb: 0, color: 'green' }} color="initial">Contact request successfully sent.</Typography>
            </Box>
          ) : ( <></> )}
          <Grid container spacing={4}>
            <Grid item md={12} sx={{ display: showSearch ? 'none' : 'block' }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h2" fontSize={20} color="initial">Identify initial contact</Typography>
              </Box>

              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="method-select-label">Method</InputLabel>
                <Select
                  labelId="method-select-label"
                  id="method-select"
                  value={methodChoice}
                  label="Method"
                  onChange={handleMethodChoice}
                >
                  {methodList !== null ? 
                    methodList.map((item, index) => (
                      <MenuItem key={index} value={item.id}>{item.name.replace('&amp;', '&')}</MenuItem>
                    ))
                  : (
                    <MenuItem value={''}>Loading</MenuItem>
                  )}
                </Select>
              </FormControl>

              <FormControl fullWidth sx={{ mb: 3 }}>
                <InputLabel id="material-select-label">Material</InputLabel>
                <Select
                  labelId="material-select-label"
                  id="material-select"
                  value={materialChoice}
                  label="Material"
                  onChange={handleMaterialChoice}
                >
                  {materialList !== null ? 
                    materialList.map((item, index) => (
                      <MenuItem key={index} value={item.id}>{item.name.replace('&amp;', '&')}</MenuItem>
                    ))
                  : (
                    <MenuItem value={''}>Loading</MenuItem>
                  )}
                </Select>
              </FormControl>

              <Button variant="contained" onClick={handleSearch} fullWidth sx={{ height: '56px' }}>
                Find contact person
              </Button>
            </Grid>
            <Grid item md={12}>
              {contactPerson?.length === 0 && contactPerson !== null ? (
                <>
                  <Box sx={{ mb: 3 }}>
                      <Typography variant="h3" fontSize={18} color="initial">Result</Typography>
                  </Box>
                  <Box sx={{ border: '1px solid #c9c9c9', p: 3, borderRadius: 1, mb: 2 }}>
                    No suitable contact person found, but you can contact the people listed below to discuss your matter.
                  </Box>
                  <Grid container spacing={3}>
                    {basicContactPerson !== null ?
                      basicContactPerson.map((item, index) => (
                        <Grid item md={6}>
                          <Box key={index} sx={{ border: '1px solid #c9c9c9', p: 3, borderRadius: 1 }}>
                            <Typography variant="h4" fontSize={18} color="initial">{item.title.rendered}</Typography>
                            <Typography variant="body1" color="initial">Phone number: {item.acf.phonenumber}</Typography>
                          </Box>
                        </Grid>
                      ))
                    : (
                      <></>
                    )}
                  </Grid>
                </>
              ) : 
                contactPerson === null ? (
                  <></>
                ) : (
                  <>
                    <Box sx={{ pb: 2 }}>
                      {contactPerson.map((item, index) => (
                        <Box key={index}>
                          <Typography variant="h4" fontSize={18} color="initial">{item.title.rendered}</Typography>
                          <Typography variant="body1" color="initial">Phone number: {item.acf.phonenumber}</Typography>
                        </Box>
                      ))}
                    </Box>
                    <Box>
                        <Typography variant="h4" fontSize={16} color="initial">Make contact request</Typography>
                        <Box sx={{ mt: 2 }}>
                          <FormControl sx={{ mb: 2 }} fullWidth variant="outlined">
                            <InputLabel id="name-label">Name *</InputLabel>
                            <OutlinedInput
                              onChange={handleFormInputChange}
                              id="name"
                              label="Name *"
                            />
                          </FormControl>
                          <FormControl sx={{ mb: 2 }} fullWidth variant="outlined">
                            <InputLabel id="email-label">Email *</InputLabel>
                            <OutlinedInput
                              onChange={handleFormInputChange}
                              id="email"
                              label="Email *"
                            />
                          </FormControl>
                          <FormControl sx={{ mb: 2 }} fullWidth variant="outlined">
                            <InputLabel id="company-label">Company</InputLabel>
                            <OutlinedInput
                              onChange={handleFormInputChange}
                              id="company"
                              label="Company"
                            />
                          </FormControl>
                          <FormControl fullWidth sx={{ mb: 3 }}>
                            <InputLabel id="tasks-select-label">Task</InputLabel>
                            <Select
                              labelId="tasks-select-label"
                              id="tasks"
                              name="tasks"
                              value={taskChoice}
                              label="Task"
                              onChange={handleFormInputChange}
                            >
                              {taskList !== null ? 
                                taskList.map((item, index) => (
                                  <MenuItem key={index} value={item.id}>{item.name.replace('&amp;', '&')}</MenuItem>
                                ))
                              : (
                                <MenuItem value={''}>Loading</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                          <FormControl sx={{ mb: 2 }} fullWidth variant="outlined">
                            <InputLabel id="others-label">Other notes</InputLabel>
                            <OutlinedInput
                              onChange={handleFormInputChange}
                              id="others"
                              multiline
                              rows={4}
                              label="Other notes"
                            />
                          </FormControl>
                          {formError === true ? (
                            <Box sx={{ p: 4, border: '1px solid red', color: 'red', mb: 3 }}>
                              <Typography variant="body1" sx={{ pb: 0, color: 'red' }} color="initial">Not all required fields are filled!</Typography>
                            </Box>
                          ) : (
                            <></>
                          )}
                          {formEmailError === true ? (
                            <Box sx={{ p: 4, border: '1px solid red', color: 'red', mb: 3 }}>
                              <Typography variant="body1" sx={{ pb: 0, color: 'red' }} color="initial">Email address is not valid!</Typography>
                            </Box>
                          ) : (
                            <></>
                          )}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <LoadingButton loading={loading} loadingPosition="end" variant="contained" onClick={handleFormSubmit} sx={{ height: '56px' }}>
                              <span>Send request</span>
                            </LoadingButton>
                            <Button variant="outlined" onClick={handleReset} sx={{ height: '56px' }}>
                              Find other Contact person
                            </Button>
                          </Box>
                        </Box>
                    </Box>
                  </>
                )
              }
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
    </>
  );
}

export default App;
